import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => ({
    rootContent: {
        flexGrow: 1,
        height: '83vh'
    },
    rootContentAlt: {
        flexGrow: 1
    },
    headerContainer: {
        paddingLeft: 10
    },
    contentHeader: {
        padding: 0,
        marginTop: 47,
        marginLeft: 47,
        marginRight: 40,
        marginBottom: 22,
        alignItems: "center !important"
    },
    projectsHeader: {
        marginTop: 10,
        display: 'flex',
    },

    portfolioAnalysis: {
        paddingRight: 24
    },
    portfolioAnalysisTitle: {
        fontFamily: "Roboto",
        "&.MuiTypography-root": {
            fontSize: 25,
            fontWeight: 500,
            lineHeight: "29px",
            paddingBottom: 5,
            // letterSpacing: 1.7
        }
    },
    portfolioAnalysisText: {
        fontFamily: "Roboto",
        fontSize: 14,
        fontWeight: 400,
        lineHeight: "16px"
    },
    portfolioAnalysisValue: {
        fontFamily: "Lato!important",
        fontSize: 14,
        fontWeight: 700,
        lineHeight: "17px",
        color: '#232033'
    },
    tableCointainer: {
        borderRadius: 6,
        border: "solid 1px #EBEBEB",
        backgroundColor: "#fff",
        padding: 24
    },
    dataSourcesHead: {
        paddingBottom: 24
    },
    tableHeader: {
        borderRadius: 6,
        backgroundColor: "#F9FAFB",
        color: "#667085",
        height: 44,
        padding: 12,
        '& .MuiTableCell-stickyHeader': {
            textAlign: "left",
            backgroundColor: "#F9FAFB",
        },
        '& td:first-child': {
          borderRadius: '6px 0 0 6px'
        },
        '& td:last-child': {
          borderRadius: '0 6px 6px 0',
          textAlign: "center",
        },
        '& td': {
            padding: 12,
            fontFamily: 'Roboto',
            fontStyle: 'normal',
            fontWeight: 500,
            fontSize: '14px',
            lineHeight: '18px',
        },
    },
    tableCell: {
        borderBottom: "none !important",
        fontFamily: "Roboto",
        fontSize: 12,
        lineHeight: "14px",
        color: "#312E40",
        fontWeight: 400,
        paddingTop: 0,
        paddingBottom: 0
    },
    tableRow: {
        backgroundColor: "#eef0f4",
        '& td:first-child': {
            borderRadius: '6px 0 0 6px'
        },
        '& td:last-child': {
            borderRadius: '0 6px 6px 0'
        },
        height: 60,
    },
    sourcesCount: {
        fontWeight: 500,
        fontSize: 16,
        lineHeight: "18px",
        marginLeft: 43,
        color: '#7E7C87'
    },
    addNewDataButton: {
        width: 172,
        height: 40,
        padding: 0
    },
    dataCount: {
        color: '#6a6c71',
        fontSize: 16,
        cursor: "pointer",
        paddingBottom: 5,
    },
    dataCountActive: {
        color: '#312e40',
        borderBottom: "2px solid #363ed3",
    },
    dataCountFilter: {
        cursor: "pointer",
        '&:first-child': {
            marginRight: 15
        },
        '& .MuiTypography-body1':
        {
            fontSize: 13
        }
    },
    dataCountFilterActive: {
        borderBottom: "2px solid #363ed3",
    },
    dataSortBy: {
        color: '#6a6c71',
        fontSize: 13,

    },
    refreshButtonText: {
        fontSize: 12,
        color: 'black',
        marginLeft: 5
    },
    searchIcon: {
        fontSize: 20,
        color: 'black'
    },
    refreshButton: {
        fontSize: 20,
        color: 'black',
        transform: 'scaleX(-1) rotate(180deg)',

    },
    searchInput: {
        fontSize: 12,
        maxWidth: "unset",
        width: "100%"
    },
    searchInputContainer: {
        fontSize: 12,
        marginBottom: "13%"

    },
    searchByContainer: {
        "& ol li.MuiBreadcrumbs-separator": {
            margin: 0
        }
    },
    searchByText: {
        display: "flex",
        alignItems: "center"
    },
    searchByButton: {
        padding: "0 3px",
        minWidth: "unset",
        "&:hover , &:focus": {
            backgroundColor: "transparent"
        }
    },
    searchByButtonActive: {
        color: "#363ed3"
    },
    containerDataSources: {
        marginLeft: 47,
        paddingBottom: 37
    },
    tableDataSources: {
        backgroundColor: '#fff',
        borderRadius: 6,
        borderCollapse: 'collapse'
    },
    dataSourceContainer: {
        borderBottom: "1px solid #EAECF0",
        '& .MuiTableCell-root': {
            padding: 12,
            fontSize: 14,
            fontWeight: 500,
            color: "#312E40",
            '& svg': {
                fill: "#3D3D3D",
            }
        }
    },
    datasourceFirstContainer: {
        display: 'flex',
        alignItems: 'baseline'
    },
    dataSourceDateContainer: {
        marginTop: 5,
        marginBottom: 14,
    },
    dataSourceDate: {
        fontSize: 11,
        color: "#6a6c71",
        padding: '0 5px'
    },
    dataSourceType: {
        fontSize: 11,
        color: "#6a6c71"
    },
    dotsContainer: {
        position: "absolute",
        right: "7.5%"
    },
    nameContainer: {
        display: "flex",
        alignItems: "center",
        gap: 12
    },
    dotsMenu: {
        "&:hover": {
            backgroundColor: "#dee9fe"
        }
    },
    filterButton: {
        marginRight: 3,
        color: "#52525299",
        width: '18px!important',
        height: '18px!important',
    },
    filterButtonInverted: {
        transform: 'scaleX(-1) rotate(180deg)'
    },
    FilterContainer: {
        borderRadius: 6,
        fontFamily: 'Roboto',
        fontStyle: 'normal',
        fontWeight: 700,
        fontSize: '12px',
        lineHeight: '16px',
        cursor: 'pointer',
        display: 'flex',
        justifyContent: 'start'

    },
    FilterTypeContainer: {
        borderRadius: 6,
        display: 'flex',
        justifyContent: 'flex-start',
        minWidth: 180,

    },
    ActiveFilter: {
        border: 'solid 1px #363ed3'
    },
    centerAligned: {
        display: "flex",
        alignItems: "center"
    },
    DividerStyle: {
        height: 32,
        marginTop: "2.9%"
    },
    noResult: {
        minHeight: 250,
        alignItems: "center"
    },
    popoverContainer: {
        "& .MuiPaper-root": {
            background: "#fff",
            borderRadius: 6,
            border: "1px solid #D9E1EE",
            boxShadow: "0px 3px 5px rgba(0, 0, 0, 0.05)"
        }
    },
    actionsPopoverContainer: {
        borderRadius: 6,
        backgroundColor: "#fff",
        padding: 12,
    },
    actionButtonContainer: {
        width: '100%',
        textAlign: "left",
        cursor: "pointer",
        "&:hover": {
            backgroundColor: "#0000001f"
        }
    },
    actionButton: {
        color: "#312E40",
        padding: "3px 0",
        margin: 0,
        fontFamily: "Roboto",
        fontSize: "14px!important",
        fontWeight: "400!important",
        "& a": {
            color: "#312E40",
            textDecoration: "none"
        } 
    }
}));